export default __webpack_public_path__ + "static/media/insulin-noon-icon.0bd21381.svg";